import { useSelector } from "react-redux";
import { IAppState } from "../../Common";

export const useActiveContext = () => {
  return useSelector((state: IAppState) => ({
    activeApp: state.app.activeApp,
    activeTopic: state.app.activeTopic
  }));
};
